<script>
    export default {        
      bind (el, binding, vnode) {
            // console.log("binding ", el, binding, vnode);
            el.addEventListener('click', function(event) {              
                // console.log("arg", binding.arg);
                // console.log("values", binding.value);
                    let arg = binding.arg;          
                    let json = JSON.parse(localStorage.getItem("history"));
                    let data = {"ZONE":arg.toUpperCase(), "ITEM": binding.value };

                    // console.log("json = %o , data = %o", json, data);                    
                    // event.stoppropagation();                                    
                    if(json){                     
                        let r = _.find(json, function(o) { return (o.ITEM.id == binding.value.id);});
                        if(typeof r == 'undefined'  || r == null){                          
                            json.push(data);
                            localStorage.setItem("history", JSON.stringify(json));
                        }
                    }else{
                        json = [];
                        json.push(data);
                        localStorage.setItem("history", JSON.stringify(json));
                    }           
                                    
            });
          },
        unbind: function(el) {
            el.removeEventListener('click',function(){});
            // console.log("unbinding");
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/shared/directive/RecordCommonLinkHistory.vue